import React from "react";
import { Row, Col, Button } from "antd";
import { InfoNotification } from "@components";
import Chrome from "@assets/images/pages/apps/3.png";
import IoS from "@assets/images/pages/apps/1.png";
import Android from "@assets/images/pages/apps/2.png";
import { useTranslation } from "react-i18next";

const CopilotlyApps = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[0, 16]} align="middle" justify="space-between">
        <Col sm={12} span={24}>
          <span className="h2 hp-text-color-black-bg hp-text-color-dark-0 hp-d-block">
            {t("apps.copilotlyApps")}
          </span>
        </Col>
      </Row>

      {/* Chrome */}
      <Col
        xs={8}
        sm={16}
        md={24}
        lg={32}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <div className="hp-border-2 hp-overflow-hidden hp-border-color-black-40 hp-border-color-dark-80 hp-border-radius hp-bg-color-black-0 hp-bg-color-dark-100 hp-p-6">
          <Row>
            {/* Logo */}
            <Col span={4}>
              <img
                src={Chrome}
                alt="Copilotly Chrome"
                style={{
                  width: "100px",
                  height: "auto",
                  marginLeft: "22px",
                }}
              />
            </Col>

            {/* Device */}
            <Col
              span={12}
              style={{
                marginTop: "28px",
              }}
            >
              <span className="hp-d-block h4">
                {" "}
                {t("apps.copilotlyForChrome")}
              </span>
              {/* Sub heading */}
              <span className="hp-d-block hp-p1-body hp-mt-4">
                {t("apps.chromeExtension")}
              </span>
            </Col>

            {/* App actions */}
            <Col
              span={8}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Row>
                {/* Install */}
                <Button
                  type="primary"
                  size="large"
                  style={{
                    marginRight: "35px",
                  }}
                  onClick={() =>
                    window.open(
                      "https://chrome.google.com/webstore/detail/copilotly-your-personal-a/fnpfnkfggchkcaheehdgmdapnomokajo",
                      "_blank"
                    )
                  }
                >
                  {t("apps.install")}
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
      </Col>

      {/* IoS */}
      <Col
        xs={8}
        sm={16}
        md={24}
        lg={32}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <div className="hp-border-2 hp-overflow-hidden hp-border-color-black-40 hp-border-color-dark-80 hp-border-radius hp-bg-color-black-0 hp-bg-color-dark-100 hp-p-6">
          <Row>
            {/* Logo */}
            <Col span={4}>
              <img
                src={IoS}
                alt="Copilotly IoS"
                style={{
                  width: "100px",
                  height: "auto",
                  marginLeft: "25px",
                }}
              />
            </Col>

            {/* Device */}
            <Col
              span={12}
              style={{
                marginTop: "28px",
              }}
            >
              <span className="hp-d-block h4">
                {" "}
                {t("apps.copilotlyForiOS")}
              </span>
              {/* Sub heading */}
              <span className="hp-d-block hp-p1-body hp-mt-4">
                {" "}
                {t("apps.iosApp")}
              </span>
            </Col>

            {/* App actions */}
            <Col
              span={8}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Row>
                {/* Install */}
                <Button
                  type="primary"
                  size="large"
                  style={{
                    marginRight: "35px",
                  }}
                  onClick={() => InfoNotification("Coming soon...")}
                >
                  {t("apps.comingSoon")}
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
      </Col>

      {/* Android */}
      <Col
        xs={8}
        sm={16}
        md={24}
        lg={32}
        style={{ marginTop: "20px", marginBottom: "20px" }}
      >
        <div className="hp-border-2 hp-overflow-hidden hp-border-color-black-40 hp-border-color-dark-80 hp-border-radius hp-bg-color-black-0 hp-bg-color-dark-100 hp-p-6">
          <Row>
            {/* Logo */}
            <Col span={4}>
              <img
                src={Android}
                alt="Copilotly Android"
                style={{
                  width: "100px",
                  height: "auto",
                  marginLeft: "25px",
                }}
              />
            </Col>

            {/* Device */}
            <Col
              span={12}
              style={{
                marginTop: "28px",
              }}
            >
              <span className="hp-d-block h4">
                {t("apps.copilotlyForAndroid")}
              </span>
              {/* Sub heading */}
              <span className="hp-d-block hp-p1-body hp-mt-4">
                {t("apps.androidApp")}
              </span>
            </Col>

            {/* App actions */}
            <Col
              span={8}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <Row>
                {/* Install */}
                <Button
                  type="primary"
                  size="large"
                  style={{
                    marginRight: "35px",
                  }}
                  onClick={() => InfoNotification("Coming soon...")}
                >
                  {t("apps.comingSoon")}
                </Button>
              </Row>
            </Col>
          </Row>
        </div>
      </Col>
    </>
  );
};

export default CopilotlyApps;
